module.exports = __webpack_public_path__ + "static/img/formulary.ccf6cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formulary.jpg
// module id = 192
// module chunks = 1